<template>
  <div class="relative">
    <div class="relative">
      <div class="flex justify-between items-center">
        <span class="range-label bold-label">Class</span>
        <div class="alert alert-success blended-value" style="flex: 0 1 auto;">
          <span class="range-value mr-2 text-right">{{100 - Number(blendPercent)}}%</span>
          <span class="vertical-separator"></span>
          <span class="range-value ml-2">{{blendPercent}}%</span>
        </div>
        <span class="range-label bold-label text-right">Component</span>
      </div>
      <div class="range">
        <b-form-input class="range__input"
          id="classPercent"
          :disabled="disabled"
          v-model="blendPercent"
          type="range"
          min="0"
          max="100">
        </b-form-input>
        <span class="range__fill" :style="{ width: `${blendPercent}%` }"></span>
      </div>
      <div class="flex justify-between">
        <span class="range-label bold-label">~{{maxCalcValue.toLocaleString()}} LBS</span>
        <span class="range-label bold-label">~{{minCalcValue.toLocaleString()}} LBS</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex';

export default {
  props: {
    milkProduction: Number,
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      minLabel: 'Class',
      maxLabel: 'Component',
    };
  },

  computed: {
    ...mapState(['insuranceBlend', 'availability']),
    blendPercent: {
      get() {
        return this.insuranceBlend;
      },
      set(value) {
        return this.updateInsuranceBlend(parseFloat(value));
      },
    },
    minCalcValue() {
      const rawValue = this.milkProduction * (Number(this.blendPercent) / 100);
      return Math.round(rawValue / 1000) * 1000;
    },
    maxCalcValue() {
      const rawValue = this.milkProduction * ((100 - Number(this.blendPercent)) / 100);
      return Math.round(rawValue / 1000) * 1000;
    },
  },

  watch: {
    // availability(newValue) {
    //   if (!newValue.class) this.updateInsuranceBlend(100);
    //   if (!newValue.componentClassIII && !newValue.componentClassIV) this.updateInsuranceBlend(0);
    // },
  },

  methods: {
    ...mapMutations(['updateInsuranceBlend']),

    updateInsBlend(value) {
      this.updateInsuranceBlend(parseFloat(value));
    },
  },
};
</script>

<style>
.blended-value {
  @apply flex items-end justify-center relative mb-0 py-1;
  margin: 0 auto;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: -20%;
  z-index: -1;
}
</style>
